<template>
    <Navbar :title="'订单详情'" :rightBtn="true"></Navbar>
    <div class="wrap-box-d warp-order-setup">
        <div class="wrap-box-title">
            {{detail.provider.name}}
        </div>
        <div class="card">
            <div class="card-title">
                    <div class="flex-title-text">
                        订单号: {{detail.sn}}
                    </div>
                </div>
        </div>
    </div>
    <!-- <div class="wrap-box-d warp-order-setup">
        <div class="wrap-box-title">
            服务内容
        </div>
        <div class="card">
            <span class="serve-c" v-for="item in items" :key="item.name">
                <span class="flex-title-text">
                    {{item.name}}
                </span>
            </span>
        </div>
    </div> -->
    <div class="wrap-box-d warp-order-setup">
        <div class="wrap-box-title">
            订单状态更新
        </div>
        <div>
            <div class="card card-steps">
                <div class="card-title">
                    <div class="flex-title-text">
                        进度记录
                    </div>
                </div>
                <div class="card-content">
                    <van-steps direction="vertical"
                        :active="-1">
                        <van-step v-for="step in detail.order_record" :key="step">
                            <div>{{ step.modify_time }}</div>
                            <div>{{ step.remarks }}</div>
                        </van-step>
                    </van-steps>
                </div>
            </div>
        </div>
    </div>
    
    <!-- <div v-if="detailShow.length" style="padding-bottom:90px;"> -->
    <div style="padding-bottom:90px;">
    <div class="wrap-box-d warp-order-setup">
        <div class="wrap-box-title">
            申报政策详情
        </div>
        <div class="">
            <div class="title-header">
                <div class="title small" v-if="detail && detail.title">{{ detail.title }}</div>
                <div class="match-detail small">
                    <div class="field-normal" >
                        <div class="field-item">
                            <div class="field-label" v-if="detail && detail.click_num">阅读量: {{ detail.click_num || 0 }}
                            </div>
                        </div>
                        <div class="field-item" style="text-align:right;">
                            <div class="field-label" v-if="detail && detail.favorite_num">收藏量: {{detail.favorite_num}}</div>
                        </div>
                        <!-- <div class="field-item">
                            <div class="field-label" v-if="detail && detail.createTime">创建时间：{{ detail.createTime }}</div>
                        </div> -->
                    </div>
                    <div class="field-normal">
                        <div class="field-item" style="flex:2;">
                            <span class="field-label"> 发文部门:</span>
                    <span class="field-value" v-if="detail.department">{{ detail.department.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-for="item in detailList" :key="item.title">
        <div class="wrap-box-d" v-if="item.content">
            <div class="card">
                <div>
                    <div class="card-title">
                        <div class="flex-title-text">
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="card-content card-content-html">
                    <div v-html="item.content"></div>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>

    <div class="float-action">
        <div class="flex-item">
            <van-button class="btn" type="danger" @click="doTel">联系服务机构</van-button>
        </div>
    </div>
</template>
<script>
import { queryDeclareInfo, queryOrderById } from "@/api/home"
import moment from "moment"
import Navbar from '@/components/Navbar'
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue"
import { clickUrlToPhone } from '@/utils/index'
import store from '@/store'

export default {
    name: 'OrderDetail',
    data() {
        return {
            detail: {},
            detailList: [],
            NavbarTitle: '订单详情',
            btnType: 0,
            favorite: false,
            queryCompany: {},
            items:[]
        }
    },
    components: { Navbar },
    computed: {
        detailShow(){
            return this.detailList.filter(o=>!!o.content) || []
        }
    },
    watch: {},
    mounted() {
        this.init()
    },
    watch: {},
    methods: {
        init() {
            this.id = this.$route.query.id
            this.btnType = this.$route.query.btnType
            this.getData()
        },
        async getData() {
            let res = await queryOrderById({ 'id': this.id })
            this.detail = res.result || {}
            if(res.result.declare_id){
                this.getPolicyData(res.result.declare_id)
            }
        },
        async getPolicyData(id) {
            let res = await queryDeclareInfo({ 'id': id })
            this.detail = Object.assign({}, this.detail, res.result)
            this.detailList = [
                { title: '核心内容', content: res.result.content },
                // { title: '扶持条件', content: res.result.support_conditions },
                // { title: '申报材料', content: res.result.filing_materials },
                // { title: '申报流程', content: res.result.declaration_process },
                // { title: '联系方式', content: res.result.contact_phone },
                // { title: '政策文件', content: res.data.dispatchDepartment }
            ]
        },
        doTel() {
            if (!this.detail.provider.phone) {
                this.$toast('暂无服务商电话')
                return false
            }
            clickUrlToPhone('', { phone: this.detail.provider.phone, type: 'getTel' })
        }
    },
     beforeRouteLeave(to, from, next) {
        // 离开的时候，非以下页面则删除缓存组件 name
        // 记录路由处的name值
        let coms = ['Order'];
        console.log(coms.indexOf(to.name) === -1, to.name);
        if (coms.indexOf(to.name) === -1) {
        store.commit('REMOVE_KEEP_ALIVE_COM', 'Order')
        }
        next()
    }
}
</script>
<style lang="scss" scoped>
.policy-detail-container {
    padding: 13px;
}

.title-header {
    background: #fff;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 400;
    color: #949494;
    margin: 10px 15px 0;

    .title {
        font-size: 14px;
        font-weight: 500;
        color: #000;
        margin-bottom: 6px;
    }
}

.wrap-box-d {
    padding: 13px 0;
    margin: 20px;
    border-radius: 8px;
    background: #fff;

    &.warp-order-setup {

        .card-title {
            &:before {
                width: 4px;

                border-left: 4px solid #F3B30E;
            }
        }
    }
}

.wrap-box-title {
    padding: 0 13px;
    font-size: 16px;
    font-weight: 600;
    color: #006D9B;
    line-height: 19px;
    .icon{
        display: inline-block;
        width: 12px;
        height: 14px;
        vertical-align: middle;
        margin-right:5px;
    }
}

.card {
    padding: 0 13px;
    background: #fff;
    margin: 0;
    width: auto;

    .van-cell {
        padding: 6px;
    }

    .card-title {
        font-size: 12px;
        font-weight: 550;
        color: #000;
        margin-bottom: 0;
        vertical-align: middle;
        display: flex;
        align-items: center;

        &:before {
            content: '';
            height: 10px;
            border-left: 10px solid #0F96E9;
            margin-top: 1px;
        }

    }
}

.btn-setup {
    width: 175px;
    height: 32px;
    background: linear-gradient(129deg, #1091E8 0%, #1A6FE0 100%);
    border-radius: 6px;
    opacity: 0.8;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 19px;
    border: 0;
    margin: auto;
    display: block;
}


.warp-order-setup {
    background: #fff;
    .card-content {
        margin: 0;
    }
    .card-title {
        margin-top: 8px;
    }
}

.card-content {
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    line-height: 16px;
    margin: 10px 0 0 0;
    padding: 0;
}
.field-normal{
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    .field-item{
        flex:1;
    }
}
.card-steps{
    padding: 0 13px;
    >div{
    border:0 !important;  
}
}
input.van-field__control{
    background: #f3f3f3;
    padding-left: 10px;
    height: 30px;
    border-radius: 5px;
    font-size: 12px;
}

.serve-c{
    display: inline-block;
    margin-right: 10px;
}
</style>

